import { Badge, Container, Divider, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import AbaUploads from "./abaUploads";
import AbaNotas from "./abaNotas";
import NotaDb from "../../../db/notaDb";
import { SituacaoNota, SituacaoUpload } from "../../../models/enum";
import { useUsuario } from "../../../providers/usuarioProvider";
import { limit, onSnapshot, query, where } from "firebase/firestore";
import UploadDb from "../../../db/uploadDb";
import { useLocation, useNavigate } from "react-router-dom";
import AbaSubscricoes from "./abaSubscricoes";
import AbaConexoes from "./abaConexoes";
import ConexaoDb from "../../../db/conexaoDb";

export default function Importacao() {
  const navigate = useNavigate();
  const { visualizado } = useUsuario();
  const [tab, setTab] = useState("uploads");
  const [notasProblematicas, setNotasProblematicas] = useState(false);
  const [uploadsProblematicos, setUploadsProblematicos] = useState(false);
  const location = useLocation();
  const [haConexoes, setHaConexoes] = useState(false);

  useEffect(() => {
    if (!!location.hash) setTab(location.hash.slice(1));
  }, [location.hash]);

  useEffect(() => {
    if (!!visualizado)
      return onSnapshot(
        query(
          new UploadDb().collection({ usuarioId: visualizado, uploadId: "" }),
          where("situacao", "!=", SituacaoUpload.IMPORTADO),
          limit(1)
        ),
        (snapshot) => {
          if (!snapshot.empty) {
            setUploadsProblematicos(true);
          } else {
            setUploadsProblematicos(false);
          }
        }
      );
  }, [visualizado]);

  useEffect(() => {
    if (!!visualizado)
      return onSnapshot(
        query(
          new NotaDb().collection({ usuarioId: visualizado, notaId: "" }),
          where("situacao", "!=", SituacaoNota.Pronta),
          limit(1)
        ),
        (snapshot) => {
          if (!snapshot.empty) {
            setNotasProblematicas(true);
          } else {
            setNotasProblematicas(false);
          }
        }
      );
  }, [visualizado]);

  useEffect(() => {
    if (!!visualizado) {
      return onSnapshot(
        query(
          new ConexaoDb().collection({ usuarioId: visualizado, conexaoId: "" }),
          limit(1)
        ),
        (snapshot) => setHaConexoes(!snapshot.empty)
      );
    }
  }, [visualizado]);

  const handleTabChange = (
    _event: React.SyntheticEvent<Element, Event>,
    value: string
  ) => {
    setTab(value);
    navigate(`${location.pathname}#${value}`, { replace: true });
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <TabContext value={tab}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          // Indicador e rótulo em accent-ink: `primary.main` reprova em WCAG
          // sobre superfície escura (DESIGN.md → accent vs. accent-ink).
          TabIndicatorProps={{
            sx: (theme) => ({
              height: 2,
              backgroundColor: theme.palette.accentInk,
            }),
          }}
          sx={(theme) => ({
            minHeight: 40,
            "& .MuiTab-root": {
              minHeight: 40,
              px: 2,
              textTransform: "none",
              fontWeight: 500,
              letterSpacing: 0,
              color: theme.palette.text.secondary,
              "&.Mui-selected": { color: theme.palette.text.primary },
            },
          })}
        >
          {haConexoes && <Tab value="conexoes" label="Conexões" />}
          <Tab
            value="uploads"
            label={
              <Badge
                variant="dot"
                color="error"
                invisible={!uploadsProblematicos}
              >
                Uploads
              </Badge>
            }
          />
          <Tab
            value="notas"
            label={
              <Badge
                variant="dot"
                color="error"
                invisible={!notasProblematicas}
              >
                Notas
              </Badge>
            }
          />
          <Tab value="subscricoes" label="Subscrições" />
        </Tabs>
        <Divider />
        {haConexoes && (
          <TabPanel sx={{ px: 0 }} value="conexoes">
            <AbaConexoes />
          </TabPanel>
        )}
        <TabPanel sx={{ px: 0 }} value="uploads">
          <AbaUploads />
        </TabPanel>
        <TabPanel sx={{ px: 0 }} value="notas">
          <AbaNotas />
        </TabPanel>
        <TabPanel sx={{ px: 0 }} value="subscricoes">
          <AbaSubscricoes />
        </TabPanel>
      </TabContext>
    </Container>
  );
}
